const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const ArrowIcon = require("./ArrowIcon");
const ScrollArea = require("./ScrollArea");
const Analytics = require("../util/Analytics");
const AssetsUtil = require("../util/AssetsUtil");
const Sounds = require("../util/Sounds");

const styles = require("./styles/DropdownSelect.css");

module.exports = createReactClass({
	displayName: "DropdownSelectView",

	propTypes: {
		options: PT.object.isRequired, //{keyValue: option}
		disabledOptions: PT.arrayOf(PT.string), //list of keys for options that are disabled
		defaultOption: PT.string, //placeholder option string
		customPreviews: PT.object, // Show the thing mapped here when option is selected
		className: PT.string,
		optionHeight: PT.number, //height in px of each option
		numOptionsShown: PT.number, //number of options shown when dropdown is open
		initialValue: PT.oneOfType([PT.string, PT.number]),
		updateSelection: PT.func,
		isSearchable: PT.bool,
		smallerPadding: PT.bool,
		tabIndex: PT.number,
		nameAttr: PT.string,
		autocompleteAttr: PT.string,
		orderOptions: PT.string, // "asc", "desc"
		customSortedOptionKeys: PT.arrayOf(PT.string), //list of option keys in custom order
		disablePreviewOpen: PT.bool, // Don't open dropdown when preview is clicked, only when arrow is clicked.
		//styles & classnames for various parts of the dropdown
		mainStyle: PT.object,
		previewStyle: PT.object,
		optionStyle: PT.object,
		arrowStyle: PT.object,
		previewClass: PT.string,
		containerClass: PT.string,
		optionClass: PT.string,
		defaultOptionClass: PT.string,
		previewDefaultClass: PT.string,
		arrowClass: PT.string,
		openArrowClass: PT.string,
		openPreviewClass: PT.string,
		arrowType: PT.string,
		arrowColor: PT.string,
		arrowImage: PT.string,
		hasSounds: PT.bool,
	},

	getDefaultProps: function() {
		return {
			optionHeight: 50,
			numOptionsShown: 7,
			className: "",
			previewClass: "",
			arrowClass: "",
			optionClass: "",
		};
	},

	getInitialIndex: function(props) {
		let initialIndex;
		if (props.initialValue) {
			initialIndex = Math.max(
				0,
				_.findIndex(this.getOptions(props), opt => props.initialValue === opt)
			);
		}
		return initialIndex;
	},

	getInitialState: function() {
		const options = this.getOptions(this.props);
		const selectedIndex = this.getInitialIndex(this.props) || 0;
		return {
			isOpen: false,
			options,
			availableOptions: _.omit(this.props.options, this.props.disabledOptions),
			selectedIndex,
			searchString: "",
		};
	},

	componentDidMount() {
		// Ensures that when user touches outside of the input,
		// the dropdown is closed.
		this.isTouchingInput = false;
		document.addEventListener("touchend", this.onDocumentTouchEnd);
	},

	componentWillUnmount: function() {
		document.removeEventListener("touchend", this.onDocumentTouchEnd);
	},

	UNSAFE_componentWillReceiveProps: function(nextProps) {
		const options = this.getOptions(nextProps);
		if (
			!_.isEqual(options, this.getOptions(this.props)) ||
			!_.isEqual(nextProps.disabledOptions, this.props.disabledOptions) ||
			!_.isEqual(
				nextProps.customSortedOptionKeys,
				this.props.customSortedOptionKeys
			)
		) {
			this.setState({
				options,
				availableOptions: _.omit(nextProps.options, nextProps.disabledOptions),
				selectedIndex: this.getInitialIndex(nextProps) || 0,
				searchString: "",
			});
		} else if (this.props.initialValue !== nextProps.initialValue) {
			let newIndex = this.getInitialIndex(nextProps);
			if (!nextProps.initialValue && this.props.defaultOption) {
				newIndex = 0;
			}
			this.setState({
				selectedIndex: newIndex,
			});
		}
	},

	getOptions: function(data) {
		const {orderOptions, customSortedOptionKeys} = data;
		let options = _.keys(data.options);
		if (customSortedOptionKeys) {
			options = customSortedOptionKeys;
		} else if (orderOptions) {
			options = _.sortBy(options, o => data.options[o]);
			if (orderOptions === "desc") {
				options = _.reverse(options);
			}
		}
		if (data.defaultOption) {
			options = [""].concat(options);
		}
		return options;
	},

	getMatchIndex: function(searchString) {
		let matchIndex = -1;
		let matchString = searchString;
		if (searchString) {
			for (let i = searchString.length; i > 0; i--) {
				const toMatch = _.toLower(searchString.substring(0, i));
				// Try to match either option or its key.
				const matchOption = _.find(this.state.availableOptions, (o, key) => {
					return (
						_.startsWith(_.toLower(o), toMatch) ||
						_.startsWith(_.toLower(key), toMatch)
					);
				});
				if (matchOption) {
					matchIndex = _.toArray(this.state.availableOptions).indexOf(
						matchOption
					);
				}
				if (matchIndex > -1) {
					matchString = _.toLower(searchString.substring(0, i));
					break;
				}
			}
		}
		if (this.props.defaultOption) {
			if (!searchString) {
				matchIndex = 0;
			} else {
				matchIndex += 1;
			}
		}
		return {
			matchIndex,
			matchString,
		};
	},

	navigateDropdown: function(evt) {
		const code = evt.which;
		const {options, isOpen} = this.state;
		if (code === 38 || code === 40) {
			//Up and down arrows
			evt.preventDefault();
			if (isOpen) {
				let newIndex;
				if (code === 38) {
					//Find the first non-disabled option before the selected one
					newIndex = _.findLastIndex(
						options,
						(o, i) =>
							i < this.state.selectedIndex &&
							!_.includes(this.props.disabledOptions, o)
					);
				} else {
					//Find the first non-disabled option past the selected one
					newIndex = _.findIndex(
						options,
						(o, i) =>
							i > this.state.selectedIndex &&
							!_.includes(this.props.disabledOptions, o)
					);
				}
				if (newIndex === -1) {
					newIndex = this.state.selectedIndex;
				}
				this.setState({
					selectedIndex: newIndex,
					searchString: "",
				});
			} else {
				this.setState({
					isOpen: true,
					searchString: "",
				});
			}
		} else if (code === 13 || code === 27 || code === 32) {
			//enter, escape, and space both close
			evt.preventDefault();
			if ((code === 13 || code === 32) && !isOpen) {
				this.setState({isOpen: true, searchString: ""});
			} else if (!this.props.isSearchable || code !== 32) {
				this.closeOptions();
			}
		} else if (code === 8 && this.state.searchString.length) {
			evt.preventDefault();
			const searchString = this.state.searchString.slice(0, -1);
			if (searchString !== this.state.searchString) {
				const selectedIndex = !searchString
					? 0
					: this.getMatchIndex(searchString).matchIndex;
				this.setState({
					searchString,
					selectedIndex:
						selectedIndex > -1 ? selectedIndex : this.state.selectedIndex,
				});
			}
		}
	},

	updateSearchString: function(evt) {
		const code = evt.which;
		if (this.props.isSearchable) {
			evt.preventDefault();
			let searchString = this.state.searchString;
			let matchIndex = -1;
			if (
				(code >= 65 && code <= 90) ||
				(code >= 97 && code <= 122) ||
				(code >= 48 && code <= 57)
			) {
				searchString += String.fromCharCode(code);
			}
			if (searchString !== this.state.searchString) {
				const match = this.getMatchIndex(searchString);
				matchIndex = match.matchIndex;
				if (matchIndex > -1) {
					this.setState({
						selectedIndex: matchIndex,
						searchString: match.matchString,
					});
				} else if (!searchString) {
					this.setState({
						selectedIndex: 0,
						searchString,
					});
				}
			}
		}
	},

	selectOption: function(index) {
		const options = this.state.options;
		const content = options[index];
		if (
			this.props.disabledOptions &&
			_.includes(this.props.disabledOptions, content)
		) {
			return; //Don't select a disabled option
		}
		if (index !== this.state.selectedIndex) {
			this.props.updateSelection(content);
		}
		this.setState({
			selectedIndex: index,
			isOpen: false,
		});
	},

	toggleOptions: function() {
		if (this.props.hasSounds) {
			const clickSound = this.state.isOpen ? "arrow-left" : "arrow-right";
			Sounds.playSound(clickSound);
		}
		if (this.state.isOpen) {
			this.closeOptions();
		} else {
			this.setState({
				isOpen: true,
				searchString: "",
			});
		}
	},

	onBlur: function() {
		// IE triggers onBlur after option.onMouseDown but before option.onClick
		if (!this.hasRecentlyMousedDown) {
			this.closeOptions();
		}
	},

	closeOptions: function() {
		const options = this.state.options;
		const content = options[this.state.selectedIndex];
		this.props.updateSelection(content);
		this.setState({
			isOpen: false,
			searchString: "",
		});
	},

	mouseDownOnOption: function() {
		// IE triggers onBlur after option.onMouseDown but before option.onClick
		this.hasRecentlyMousedDown = true;
		setTimeout(() => {
			this.hasRecentlyMousedDown = false;
		}, 500);
	},

	createOptions: function() {
		const options = this.state.options;
		return options.map((opt, i) => {
			const optionStyle = _.extend({}, this.props.optionStyle, {
				height: this.props.optionHeight,
			});
			let className = styles.option;
			let extraClass = this.props.optionClass;
			let value = this.props.options[opt];
			let onClick = () => this.selectOption(i);
			if (i === this.state.selectedIndex) {
				className = styles.selected;
			}
			if (this.props.defaultOption && i === 0) {
				className = styles.defaultOption;
				extraClass = this.props.defaultOptionClass;
				value = this.props.defaultOption;
			}
			if (
				this.props.disabledOptions &&
				_.includes(this.props.disabledOptions, opt)
			) {
				className = styles.disabled;
				onClick = null;
			}
			return (
				<div
					className={className + " " + extraClass}
					style={optionStyle}
					key={opt}
					onMouseDown={this.mouseDownOnOption} // for IE
					onClick={onClick}
				>
					<span className={styles.text}>{value}</span>
				</div>
			);
		});
	},

	calculateTopPosition: function(searchString) {
		let topPosition = 0;
		const options = this.state.options;
		if (this.props.isSearchable) {
			const length = options.length + (this.props.defaultOption ? 1 : 0);
			const height = this.props.optionHeight;

			const matchIndex = this.getMatchIndex(searchString).matchIndex;
			const maxHeight =
				this.props.numOptionsShown * (this.props.optionHeight + 1);
			if (matchIndex > -1 && height * options.length >= maxHeight) {
				//This prevents the dropdown from scrolling past numOptionsShown at the end of all options
				const maxTopPosition =
					length * (height + 1) - (height + 1) * this.props.numOptionsShown;
				topPosition = Math.min(maxTopPosition, matchIndex * (height + 1)); //(match css of dropdown + 1px border)
			}
		}
		return topPosition;
	},

	onTouchStart: function() {
		this.isTouchingInput = true;
	},

	onDocumentTouchEnd: function() {
		if (!this.isTouchingInput && this.state.isOpen) {
			this.closeOptions();
		}
		this.isTouchingInput = false;
	},

	onChange: function(evt) {
		const matchIndex = this.getMatchIndex(evt.target.value).matchIndex;
		if (matchIndex > -1) {
			this.selectOption(matchIndex);
		}
	},

	render: function() {
		const {options, isOpen, selectedIndex} = this.state;
		let currSelected = this.props.options[options[selectedIndex]];

		let initialTopPosition = 0;
		if (isOpen) {
			initialTopPosition = this.calculateTopPosition(currSelected);
		}

		if (!currSelected) {
			currSelected = this.props.defaultOption;
		}

		// Style needs to be defined here because we are using third-party scroll container, which only takes in a style and not a class
		// We could modify our third-party scroll container to take in a class
		// but might need to go back and make sure all trainer pages that use scroll container still work properly
		const scrollContainerStyle = {
			backgroundColor: "#FFFFFF",
			borderLeft: "solid 1px #CCCCCC",
			width: "calc(1rem + 2px)",
			height: "calc(100% - 1px)", //account for border
			right: 1,
			zIndex: 3,
			pointerEvents: isOpen ? "auto" : "none",
		};

		const scrollbarStyle = {
			borderRadius: "10px",
			width: "1rem",
			margin: "0 1px",
		};

		const scrollAreaStyle = {
			maxHeight: this.props.numOptionsShown * (this.props.optionHeight + 1), //+1 is to account for border
		};
		let prevClass = styles.preview + " " + this.props.previewClass;
		if (
			this.props.defaultOption &&
			_.toLower(currSelected) === _.toLower(this.props.defaultOption)
		) {
			if (!this.props.defaultOptionClass) {
				prevClass += " " + styles.previewDefault;
			} else if (this.props.previewDefaultClass) {
				prevClass += " " + this.props.previewDefaultClass;
			}
		}

		const optionEls = isOpen ? (
			<ScrollArea
				areaClassName={styles.scroll}
				areaStyle={scrollAreaStyle}
				hasXScroll={false}
				yBarStyle={scrollContainerStyle}
				yThumbStyle={scrollbarStyle}
				initialYPos={initialTopPosition}
				noFade={true}
				preventOuterScroll={true}
			>
				<div className={styles.options}>{this.createOptions()}</div>
			</ScrollArea>
		) : null;

		//Hidden input type options for use in autocomplete
		const dataOptions = _.map(this.props.options, opt => {
			return <option key={opt} value={opt} />;
		});

		const autocompleteEls = [];

		if (this.props.autocompleteAttr) {
			autocompleteEls.push(
				<input
					className={styles.datalist}
					name={this.props.nameAttr}
					autoComplete={this.props.autocompleteAttr}
					onChange={this.onChange}
					list={"options" + this.props.tabIndex}
					key={"autocompleteInput"}
					{...Analytics.getHotjarSuppressionAttributes()}
				/>
			);
			autocompleteEls.push(
				<datalist id={"options" + this.props.tabIndex} key="datalist">
					{dataOptions}
				</datalist>
			);
		}

		let mainClass = styles.main;
		let extraArrowClass = this.props.arrowClass;
		if (this.props.className) mainClass += " " + this.props.className;
		if (isOpen) {
			mainClass += " " + styles.mOpen;
			extraArrowClass += " " + this.props.openArrowClass;
			prevClass += " " + this.props.openPreviewClass;
		}
		if (this.props.smallerPadding) mainClass += " " + styles.smallerPadding;
		const previewText =
			(this.props.customPreviews &&
				this.props.customPreviews[options[selectedIndex]]) ||
			currSelected;

		let arrowEl;
		if (this.props.arrowType) {
			arrowEl = (
				<ArrowIcon
					arrowClass={styles.arrowIcon}
					type={this.props.arrowType}
					colorName={this.props.arrowColor || "mainBlue"}
					direction="down"
					size="fit"
				/>
			);
		} else {
			arrowEl = (
				<img
					className={styles.arrow}
					alt="Select"
					src={AssetsUtil.getOfficeIcon(
						this.props.arrowImage || "arrow-right-red"
					)}
				/>
			);
		}

		return (
			<div
				className={mainClass}
				style={this.props.mainStyle}
				onBlur={this.onBlur}
				onTouchStart={this.onTouchStart}
				tabIndex={this.props.tabIndex == null ? -1 : this.props.tabIndex}
				onKeyPress={this.updateSearchString}
				onKeyDown={this.navigateDropdown}
			>
				<div className={styles.container + " " + this.props.containerClass}>
					{optionEls}
				</div>
				<div
					className={prevClass}
					style={this.props.previewStyle}
					onClick={
						this.props.disablePreviewOpen ? () => {} : this.toggleOptions
					}
				>
					<div>{previewText}</div>
				</div>
				<div
					className={styles.drop + " " + extraArrowClass}
					onClick={this.toggleOptions}
					style={this.props.arrowStyle}
				>
					{arrowEl}
				</div>
				{autocompleteEls}
			</div>
		);
	},
});
